angular
	.module('AutoPrequal')
	.factory('httpRequestInterceptor', function () {
	return {
		request: function (config) {
			var _req_verf_token = $('input[name="__RequestVerificationToken"]').val();
			config.headers['X-XSRF-Token'] = _req_verf_token;
			return config;
		}
	};
});